module.exports = __webpack_public_path__ + "media/svg-new/avatar-3 2-f68ccc88.svg";